import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cloudflare-proxied R2 public URL, e.g. `https://cdn.jadecrafts.in`.
// The backend pre-generates three WebP-friendly variants at upload time
// (`<uid>.<ext>` original, `<uid>_thumb.webp` 100px, `<uid>_web.webp` 800px)
// and stores their keys on the product as `image_path` / `thumb_path` /
// `web_path`. The frontend picks the right one for the grid, admin list or
// zoom view — no on-the-fly resizing needed, so this stays 100% free.
export const R2_PUBLIC_URL = (process.env.REACT_APP_R2_PUBLIC_URL || "").replace(/\/$/, "");

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Low-level URL builder. Serves the R2 object directly from the Cloudflare
// custom domain when configured, or falls back to the backend proxy in local
// dev where no public URL is set.
export function imgUrl(path) {
  if (!path) return "";
  if (R2_PUBLIC_URL) return `${R2_PUBLIC_URL}/${path}`;
  return `${API}/files/${path}`;
}

// Original — full-resolution untouched upload. Used for lightbox / zoom /
// high-res employee downloads.
export function fileUrl(path) {
  return imgUrl(path);
}

// 100px WebP thumbnail for admin lists. Falls back to the next-larger variant
// if the thumb was never generated (legacy uploads before variants existed)
// so the grid never regresses to a broken image.
export function thumbUrl(product) {
  if (!product) return "";
  if (typeof product === "string") return imgUrl(product);
  return imgUrl(product.thumb_path || product.web_path || product.image_path);
}

// 800px WebP web variant for catalogue grid + product cards. Falls back to
// the original before the 100px thumb so pre-variant records (only
// `image_path`) stay sharp at grid sizes.
export function webUrl(product) {
  if (!product) return "";
  if (typeof product === "string") return imgUrl(product);
  return imgUrl(product.web_path || product.image_path || product.thumb_path);
}
